import { TruckSizeUnion } from '../../../../../common/constants';
import { AllocationViewNextActionModel } from './allocation-view-next-action.model';

export class AllocationViewTruckActionModel {
  truck: {
    truckId: number;
    truckPlate: string;
    truckSize: TruckSizeUnion;
    truckPlateCountry: string;
    trailerPlate: string;
    trailerPlateCountry: string;
    truckStatus: string;
  };
  actions: AllocationViewNextActionModel[];
}
